// extracted by mini-css-extract-plugin
export default {"container":"l_msLQ0Ui2tdzoaWtoUw","list":"VMzMI4zlhIvAokiSDV3A","footer":"F6OJlwAZCP5UoCx8q3uC"};